export default function masks(){
    $(document).ready(function(){
        $("#phone").mask("(00) 00000-0000");
    });
    $(document).ready(function(){
        $("#cnpj").mask("00.000.000/0000-00");
    });
}